import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=51269b82&scoped=true"
import script from "./step4.vue?vue&type=script&lang=ts"
export * from "./step4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51269b82",
  null
  
)

export default component.exports